module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/is-iterable.js
// module id = ../node_modules/@babel/runtime/core-js/is-iterable.js
// module chunks = 0